import {
	Document,
	Image,
	Page,
	Path,
	Rect,
	Svg,
	Text,
	View,
} from "@react-pdf/renderer";
import ElementalLogo from "../../assets/image/Elemental_Energies_Blue.png";
import ApprovalRecordSection from "./ApprovalRecordSection";
import ProjectDetailSection from "./ProjectDetailSection";
import { styles } from "./ReactPdfStyles";
import PersonalDetailSection from "./PersonalDetailSection";
import IndividualApprovalRecordSection from "./IndividualApprovalRecordSection";
import ApprovalTimeSection from "./ApprovalTimeSection";

type Project = {
	project_name: string;
	project_code: string;
	period: string;
	operator: string;
	location: string;
};

type ApprovedTime = {
	date: string; // ISO date format (YYYY-MM-DD)
	duration: number; // duration in hours
};

type TimeEntry = {
	role: string;
	employee_name: string;
	approved_time: ApprovedTime[];
	total_approved_time: number;
};

type Approvals = {
	generated_by: string;
	generated_at: string; // ISO datetime string
};

type TimesheetPDFTypes = {
	project: Project;
	time_entries: TimeEntry[];
	approvals: Approvals;
};

const EmailIcon: React.FC<{ size?: number; color?: string; style?: any }> = ({
	size = 16,
	color = "#000",
	style,
}) => (
	<Svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		style={{ marginRight: 4, ...style }}
	>
		<Rect
			x="2"
			y="4"
			width="20"
			height="16"
			rx="2"
			ry="2"
			stroke={color}
			strokeWidth={1.5}
			fill="none"
		/>
		<Path d="M2 4l10 9 10-9" stroke={color} strokeWidth={1.5} fill="none" />
	</Svg>
);

export const TimesheetPDF = ({
	month,
	data,
	type,
}: {
	month: string;
	data: any;
	type: string;
}) => {
	console.log("TimesheetPDF data", data);
	return (
		<Document>
			<Page size="A3" style={styles.document} orientation="landscape">
				<View fixed style={styles.headerContainer}>
					<Text style={styles.title}>Timesheet</Text>
					<View style={styles.logoImageContainer}>
						<Image style={styles.logo} src={ElementalLogo} />

						<View style={styles.emailContainer}>
							<EmailIcon size={12} color="#A8A8A8" />
							<Text style={styles.email}>
								accountspayables@elementalenergies.com
							</Text>
						</View>
					</View>
				</View>
				{type === "monthly-timesheet-report" && (
					<>
						<ProjectDetailSection data={data.project} />
						<ApprovalTimeSection
							month={month}
							data={data.roles}
							type="project"
						/>
						<ApprovalRecordSection data={data.approvals} />
					</>
				)}

				{type === "individual-timesheet-report" && (
					<>
						<PersonalDetailSection
							data={{
								...data.user,
								period: month,
								total_projects: data.projects.length,
							}}
						/>
						<ApprovalTimeSection
							month={month}
							data={data.projects}
							type="individual"
						/>
						<IndividualApprovalRecordSection data={data.approvals} />
					</>
				)}
			</Page>
		</Document>
	);
};
